import { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import type { IParams } from "../App";
import { exportExcel } from "../excel";
import { useTranslations } from "../queries/useTranslations";
import { exportTranslationsSelector } from "../state/selectors";
import { type ILanguage, LANGUAGES } from "../types";

function ExportModal() {
    const { version } = useParams<IParams>();
    const [lang, setlang] = useState<ILanguage>("en");
    if (!version) {
        throw new Error("Version is not defined");
    }
    const { data: translations } = useTranslations(version);
    const exportData = useSelector((state) => exportTranslationsSelector(state, version, translations!, lang));

    const handleExport = () => {
        // Generate the Excel workbook as a Blob.
        const blob = exportExcel(exportData);
        // Create a URL for the blob.
        const url = URL.createObjectURL(blob);
        // Create a temporary anchor element to trigger the download.
        const a = document.createElement("a");
        a.href = url;
        a.download = `tm_content_${lang}.xlsx`; // File name with language tag
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // Revoke the URL once it's been used.
        URL.revokeObjectURL(url);
    };
    return (
        <div>
            <h2>Export all answer for {version} as xlsx</h2>
            <div>
                <label>
                    Select langauge to export:{" "}
                    <select value={lang} onChange={(e) => setlang(e.target.value as ILanguage)}>
                        {LANGUAGES.map((l) => (
                            <option key={l} value={l}>
                                {l}
                            </option>
                        ))}
                    </select>
                </label>
                <button type="button" onClick={handleExport}>
                    Download (xlsx)
                </button>
            </div>
        </div>
    );
}

export default ExportModal;
